import React, { Component } from 'react';
import { HttpRequest, CheckSessionNew } from '../components/common/CommonOperations';
import '../assets/customOkta.css'

export class Login extends Component {
    static displayName = Login.name;

    constructor(props) {
        super(props);
        this.state = {};
        this.oktaURL = '';
    }

    async componentDidMount() {
        console.log('Login componentDidMount');
        await this.checkSessionLogin1();
    }

    async checkSessionLogin1() {
        debugger;
        var sessionExists = await CheckSessionNew();
        if (sessionExists) {
            //alert("Login: User session available");
            console.log("Login: User session available");

            if (sessionStorage.getItem("redirectURL") != null &&
                (sessionStorage.getItem("redirectURL").indexOf('Session') === -1 && sessionStorage.getItem("redirectURL").indexOf('Login') === -1)) {
                //alert("Login: User session available. redirecting URL");
                console.log("Login: User session available. redirecting URL");
                var url = sessionStorage.getItem("redirectURL");
                sessionStorage.removeItem("redirectURL");
                window.location.href = url;
            }
            else {
                window.location.href = "/home";
            }
        }
        else {
            console.log("Login: User session not available");

            //document.getElementById('SessionTimeout').click();
        }
    }

    async checkSessionLogin() {
        debugger;
        var response = await fetch('Auth/CheckSession');
        var data = await response.json();
        this.oktaURL = data.url;
        if (data.key === 'True') {
            console.log("Login: User session not available");

            if (sessionStorage.getItem("redirectURL") == null &&
                (window.location.href.indexOf('Session') === -1 && window.location.href.indexOf('Login') === -1)) {
                sessionStorage.setItem('redirectURL', window.location.href);
                //alert('Login: User session not available');
            }
            //alert('Login: User session not available1');
            document.getElementById('SessionTimeout').click();
            //window.location.href = this.oktaURL;
        }
        else {
            //alert("Login: User session available");
            console.log("Login: User session available");

            if (sessionStorage.getItem("redirectURL") != null &&
                (sessionStorage.getItem("redirectURL").indexOf('Session') === -1 && sessionStorage.getItem("redirectURL").indexOf('Login') === -1)) {
                //alert("Login: User session available1");
                var url = sessionStorage.getItem("redirectURL");
                sessionStorage.removeItem("redirectURL");
                window.location.href = url;
            }
            else {
                window.location.href = "/home";
            }
        }
    }

    render() {
        return (<>
            <p className="textCenterSession">
                <span><img src="images/oktaNew.gif" /></span>
                <span>Signing in to Internal App.</span>
            </p>
        </>)
    }
}